"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentAddressToJSON = exports.ShipmentAddressFromJSONTyped = exports.ShipmentAddressFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentAddressFromJSON(json) {
    return ShipmentAddressFromJSONTyped(json, false);
}
exports.ShipmentAddressFromJSON = ShipmentAddressFromJSON;
function ShipmentAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salutation': !(0, runtime_1.exists)(json, 'salutation') ? undefined : json['salutation'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'additional': !(0, runtime_1.exists)(json, 'additional') ? undefined : json['additional'],
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : json['street'],
        'houseNumber': !(0, runtime_1.exists)(json, 'houseNumber') ? undefined : json['houseNumber'],
        'zipCode': !(0, runtime_1.exists)(json, 'zipCode') ? undefined : json['zipCode'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'countryCode': !(0, runtime_1.exists)(json, 'countryCode') ? undefined : json['countryCode'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : (0, _1.GenderFromJSON)(json['gender']),
        'honorific': !(0, runtime_1.exists)(json, 'honorific') ? undefined : json['honorific'],
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
    };
}
exports.ShipmentAddressFromJSONTyped = ShipmentAddressFromJSONTyped;
function ShipmentAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salutation': value.salutation,
        'country': value.country,
        'additional': value.additional,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'city': value.city,
        'countryCode': value.countryCode,
        'gender': (0, _1.GenderToJSON)(value.gender),
        'honorific': value.honorific,
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}
exports.ShipmentAddressToJSON = ShipmentAddressToJSON;
//# sourceMappingURL=ShipmentAddress.js.map